(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["customer-video-reviews"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('customer-video-reviews-v2')) {
  customElements.define('customer-video-reviews-v2', class CustomerVideoReviewsV2 extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => { if (this.isConnected && !this.ready) this.init(); });
    }
    init() {
      if (!this.querySelector('[data-modal-template]')) return;
      this.ready = true;
      this.events = new AbortController();
      const listen = (el, type, fn, extra = {}) => el.addEventListener(type, fn, { ...extra, signal: this.events.signal });
      this.cards = [...this.querySelectorAll('.cvr2__card')];
      this.videos = [...this.querySelectorAll('.cvr2__preview')];
      this.track = this.querySelector('.cvr2__track');
      this.mobile = matchMedia('(max-width:749px)');
      this.motion = matchMedia('(prefers-reduced-motion:reduce)');
      this.currentIndex = 0; this.sliderPaused = false; this.inViewport = true; this.index = 0; this.paused = false; this.isOpen = false; this.playToken = 0;
      this.modal = this.querySelector('[data-modal-template]').content.firstElementChild.cloneNode(true);
      this.modal.id = `${this.id}-popup`;
      this.modal.style.setProperty('--cvr2-modal-font', getComputedStyle(this).fontFamily);
      // The popup lives under body, outside theme transforms, sliders and overflow clipping.
      document.body.append(this.modal);
      this.panel = this.modal.querySelector('[role="dialog"]');
      this.player = this.modal.querySelector('video');
      this.status = this.modal.querySelector('[role="status"]');
      this.retry = this.modal.querySelector('.cvr2-modal__retry');
      this.closeButton = this.modal.querySelector('[data-close]');
      this.changeMedia = () => { this.layout(); this.copyStyles(); this.refresh(); };
      this.mobile.addEventListener('change', this.changeMedia);
      this.motion.addEventListener('change', this.changeMedia);
      listen(document, 'visibilitychange', () => {
        this.refresh();
        if (document.hidden && this.isOpen) this.player.pause();
      });
      listen(this.track, 'pointerdown', e => { this.pointer = { x:e.clientX, y:e.clientY }; this.dragged = false; this.holding=true;this.transition=null;this.removeAttribute('data-sliding'); }, {passive:true});
      listen(window,'pointerup',()=>{this.holding=false;this.pointer=null;this.interactUntil=performance.now()+1500;},{passive:true});
      listen(this.track,'pointerenter',e=>{if(e.pointerType==='mouse')this.hovered=true;},{passive:true});
      listen(this.track,'pointerleave',()=>{this.hovered=false;this.pointer=null;},{passive:true});
      listen(this,'focusin',()=>{this.focused=this.querySelector('.cvr2__slider').contains(document.activeElement);});
      listen(this,'focusout',()=>{queueMicrotask(()=>{this.focused=this.querySelector('.cvr2__slider').contains(document.activeElement);});});
      listen(this.track,'wheel',()=>{this.transition=null;this.removeAttribute('data-sliding');this.interactUntil=performance.now()+2000;},{passive:true});
      listen(this.querySelector('[data-slider-toggle]'),'click',()=>{this.sliderPaused=!this.sliderPaused;this.updateSliderToggle();});
      listen(this.track, 'pointermove', e => {
        if (this.pointer && Math.hypot(e.clientX-this.pointer.x,e.clientY-this.pointer.y)>12) this.dragged = true;
      }, {passive:true});
      listen(this.track, 'pointercancel', () => { this.dragged = true; this.pointer = null; this.holding=false; this.interactUntil=performance.now()+2000; }, {passive:true});
      this.cards.forEach((card,i)=>{card.dataset.origin=String(i);card.querySelector('[data-open]').setAttribute('aria-controls',this.modal.id);});
      listen(this.track,'click',e=>{
        const button=e.target.closest('[data-open]');if(!button || button.disabled)return;
        if(e.detail!==0 && this.dragged){this.dragged=false;return;}
        const card=button.closest('.cvr2__card');this.open(Number(card.dataset.origin),button);
      });
      listen(this.querySelector('[data-prev]'), 'click', () => this.navigate(-1));
      listen(this.querySelector('[data-next]'), 'click', () => this.navigate(1));
      listen(this.querySelector('[data-toggle]'), 'click', () => { this.paused=!this.paused; this.updateToggle(); this.refresh(); });
      listen(this.track,'scroll',()=>{
        if(!this.scrollFrame)this.scrollFrame=requestAnimationFrame(()=>{
          this.scrollFrame=0;
          if(this.infinite && !this.holding){const x=this.position();if(x<this.base || x>=this.base+this.cycle)this.setPosition(x);}
          this.updateNavigation();
        });
      },{passive:true});
      listen(this.closeButton, 'click', () => this.close());
      listen(this.modal, 'click', e => { if(e.target===this.modal) this.close(); });
      listen(this.modal.querySelector('[data-video-prev]'), 'click', () => this.showVideo(this.index-1));
      listen(this.modal.querySelector('[data-video-next]'), 'click', () => this.showVideo(this.index+1));
      listen(this.retry, 'click', () => { if(this.player.error) this.player.load(); this.tryPlay(); });
      listen(this.player, 'error', () => { if(this.isOpen && this.player.getAttribute('src')) { this.status.hidden=false; this.retry.hidden=false; } });
      listen(this.player, 'playing', () => { this.status.hidden=true; this.retry.hidden=true; });
      listen(document, 'keydown', e => {
        if(!this.isOpen) return;
        if(e.key==='Escape') { e.preventDefault(); this.close(); return; }
        if(e.key!=='Tab') return;
        const focusable=[...this.panel.querySelectorAll('button:not([disabled]),video[controls]')].filter(el=>el.getClientRects().length);
        const first=focusable[0], last=focusable[focusable.length-1];
        if(e.shiftKey && (document.activeElement===first || document.activeElement===this.panel)) { e.preventDefault(); last?.focus(); }
        else if(!e.shiftKey && document.activeElement===last) { e.preventDefault(); first?.focus(); }
      });
      listen(document, 'focusin', e => { if(this.isOpen && !this.panel.contains(e.target)) this.closeButton.focus({preventScroll:true}); });
      listen(this, 'shopify:block:select', e => {
        const i=this.cards.findIndex(c=>c.dataset.blockId===e.detail.blockId); if(i<0) return;
        this.sliderPaused=true;this.updateSliderToggle();this.scrollToCard(i);
      });
      listen(this.track,'playing',e=>{if(e.target.matches('.cvr2__preview'))e.target.closest('.cvr2__card').setAttribute('data-playing','');},{capture:true});
      listen(this.track,'error',e=>{if(e.target.matches('.cvr2__preview'))e.target.closest('.cvr2__card').removeAttribute('data-playing');},{capture:true});
      this.layout(); this.copyStyles();
      if('IntersectionObserver' in window) {
        this.observer=new IntersectionObserver(entries => entries.forEach(e => { e.target._visible=e.isIntersecting; this.sync(e.target); }), {threshold:.2});
        this.videos.forEach(v=>this.observer.observe(v));
      } else { this.videos.forEach(v=>v._visible=true); this.refresh(); }
      if('IntersectionObserver' in window){this.sectionObserver=new IntersectionObserver(entries=>{this.inViewport=entries[0].isIntersecting;},{threshold:0});this.sectionObserver.observe(this);}
      if('ResizeObserver' in window){let width=this.track.clientWidth;this.resizeObserver=new ResizeObserver(()=>{const next=this.track.clientWidth;if(next!==width){width=next;cancelAnimationFrame(this.resizeFrame);this.resizeFrame=requestAnimationFrame(()=>this.layout());}});this.resizeObserver.observe(this.track);}
      this.carouselFrame=requestAnimationFrame(t=>this.tick(t));
    }
    device(key) { return this.dataset[key+(this.mobile.matches?'M':'D')]==='true'; }
    columns() { return Math.max(2,Number(this.dataset.columns)||4); }
    copyStyles() {
      const style=getComputedStyle(this);
      for(let i=0;i<style.length;i++) { const key=style[i]; if(key.startsWith('--cvr2-') && /_[dm]$/.test(key)) this.modal.style.setProperty(key,style.getPropertyValue(key)); }
    }
    sync(v) {
      v.loop=this.device('loop');
      if(v._visible && v.getClientRects().length && !document.hidden && !this.constructor.active && !this.paused && this.device('auto') && !(this.dataset.reduce==='true' && this.motion.matches)) {
        if(!v.dataset.loaded) { v.querySelectorAll('source[data-src]').forEach(s=>s.src=s.dataset.src); v.dataset.loaded='true'; v.load(); }
        v.muted=true; const result=v.play(); if(result) result.catch(()=>{});
      } else v.pause();
    }
    refresh() { this.videos?.forEach(v=>this.sync(v)); }
    refreshAll() { document.querySelectorAll('customer-video-reviews-v2').forEach(el=>el.ready && el.refresh()); }
    updateToggle() {
      const button=this.querySelector('[data-toggle]');
      button.hidden=!this.device('auto') || (this.dataset.reduce==='true' && this.motion.matches);
      button.setAttribute('aria-pressed',String(this.paused));
      button.textContent=this.paused?this.dataset.previewLabel:this.dataset.pauseLabel;
    }
    layout() {
      const keep=this.currentIndex||0;
      this.transition=null; this.removeAttribute('data-sliding');
      this.observer?.disconnect();
      this.track.querySelectorAll('[data-clone]').forEach(card=>{card.querySelector('video')?.pause();card.remove();});
      this.infinite=this.device('infinite') && this.cards.length>1;
      this.dataset.infiniteActive=String(this.infinite);
      const first=this.cards[0]; if(!first) return;
      const gap=parseFloat(getComputedStyle(this.track).columnGap)||0;
      this.step=first.getBoundingClientRect().width+gap;
      this.cycle=this.step*this.cards.length; this.base=0;
      if(this.infinite && this.step>0) {
        const copies=Math.max(1,Math.ceil(this.track.clientWidth/this.cycle));
        this.base=copies*this.cycle;
        const cloneCard=(card,i)=>{
          const clone=card.cloneNode(true);clone.dataset.clone='true';clone.dataset.origin=String(i);clone.setAttribute('aria-hidden','true');
          [clone,...clone.querySelectorAll('*')].forEach(el=>{el.removeAttribute('id');[...el.attributes].forEach(a=>{if(a.name.startsWith('data-shopify-'))el.removeAttribute(a.name);});});
          clone.querySelectorAll('button').forEach(b=>b.tabIndex=-1);
          const v=clone.querySelector('video');if(v){v.removeAttribute('data-loaded');v.querySelectorAll('source').forEach(s=>s.removeAttribute('src'));v.muted=true;v.defaultMuted=true;}
          clone.removeAttribute('data-playing');return clone;
        };
        for(let n=0;n<copies;n++) this.cards.forEach((c,i)=>this.track.insertBefore(cloneCard(c,i),first));
        for(let n=0;n<copies;n++) this.cards.forEach((c,i)=>this.track.append(cloneCard(c,i)));
      }
      this.videos=[...this.track.querySelectorAll('.cvr2__preview')];
      this.videos.forEach(v=>{v.muted=true;v.defaultMuted=true;if(this.observer)this.observer.observe(v);else if(!('IntersectionObserver' in window))v._visible=true;});
      this.setPosition(this.base+keep*this.step);
      this.querySelector('.cvr2__nav').hidden=this.cards.length<=1 || (!this.infinite && this.track.scrollWidth<=this.track.clientWidth+2);
      this.updateToggle(); this.updateSliderToggle(); this.updateNavigation(); this.refresh();
    }
    position() { return Math.abs(this.track.scrollLeft); }
    setPosition(value) {
      if(this.infinite && this.cycle>0) value=this.base+((value-this.base)%this.cycle+this.cycle)%this.cycle;
      else value=Math.max(0,Math.min(value,this.track.scrollWidth-this.track.clientWidth));
      this.track.scrollLeft=-value; // Browsers expose a negative scrollLeft for RTL rows.
    }
    updateNavigation() {
      if(!this.step) return;
      const position=this.position(),max=Math.max(0,this.track.scrollWidth-this.track.clientWidth);
      const raw=Math.round((position-this.base)/this.step);
      this.currentIndex=this.infinite?((raw%this.cards.length)+this.cards.length)%this.cards.length:Math.max(0,Math.min(raw,this.cards.length-1));
      if(!this.infinite && position>=max-2 && this.mobile.matches)this.currentIndex=this.cards.length-1;
      this.querySelector('[data-prev]').disabled=!this.infinite && position<=2;
      this.querySelector('[data-next]').disabled=!this.infinite && position>=max-2;
      const counter=this.querySelector('[data-page]'),label=`${this.currentIndex+1} / ${this.cards.length}`;if(counter.textContent!==label)counter.textContent=label;
    }
    duration() { return this.motion.matches?0:Number(this.dataset[this.mobile.matches?'durationM':'durationD'])||550; }
    animateTo(target) {
      const duration=this.duration();
      this.interactUntil=performance.now()+duration+1500;
      if(!duration){this.setPosition(target);this.updateNavigation();return;}
      this.transition={from:this.position(),target,start:performance.now(),duration};
      this.dataset.sliding='true';
    }
    scrollToCard(i) { this.animateTo(this.base+Math.max(0,Math.min(i,this.cards.length-1))*this.step); }
    navigate(step) {
      if(!this.step || this.transition) return;
      let target=this.position()+step*this.step;
      if(!this.infinite)target=Math.max(0,Math.min(target,this.track.scrollWidth-this.track.clientWidth));
      this.animateTo(target);
    }
    updateSliderToggle() {
      const button=this.querySelector('[data-slider-toggle]');
      button.hidden=!this.infinite || !this.device('scroll') || this.motion.matches;
      button.setAttribute('aria-pressed',String(this.sliderPaused));
      button.textContent=this.sliderPaused?this.dataset.sliderResumeLabel:this.dataset.sliderPauseLabel;
    }
    tick(now) {
      if(!this.ready)return;
      const elapsed=this.lastTick?Math.min(now-this.lastTick,50):0;this.lastTick=now;
      if(this.transition){
        const t=this.transition,p=Math.min(1,(now-t.start)/t.duration),ease=1-Math.pow(1-p,3);
        this.setPosition(t.from+(t.target-t.from)*ease);
        if(p===1){this.transition=null;this.removeAttribute('data-sliding');}
        this.updateNavigation();
      } else if(this.infinite && this.device('scroll') && !this.sliderPaused && !this.motion.matches && !document.hidden && !this.constructor.active && this.inViewport && !this.hovered && !this.focused && !this.holding && now>(this.interactUntil||0)) {
        const speed=Number(this.dataset[this.mobile.matches?'speedM':'speedD'])||20;
        this.setPosition(this.position()+elapsed*speed/1000);this.updateNavigation();
      }
      this.carouselFrame=requestAnimationFrame(t=>this.tick(t));
    }
    open(index,opener) {
      if(!this.cards[index]?.querySelector('video')) return;
      if(this.constructor.active && this.constructor.active!==this) this.constructor.active.close(false);
      this.opener=opener; this.isOpen=true; this.constructor.active=this;
      this.transition=null;this.removeAttribute('data-sliding');this.copyStyles(); this.modal.hidden=false;
      this.lockPage(); this.refreshAll();
      this.showVideo(index); // Synchronous play() stays inside the mobile tap gesture.
      this.closeButton.focus({preventScroll:true});
    }
    showVideo(index) {
      if(index<0 || index>=this.cards.length) return;
      const card=this.cards[index], preview=card.querySelector('video'); if(!preview) return;
      this.index=index;
      this.player.pause(); this.status.hidden=true; this.retry.hidden=true;
      const source=card.dataset.fullSrc || preview.querySelector('source[data-src]')?.dataset.src;
      if(!source) {this.status.hidden=false;return;}
      const poster=card.querySelector('img.cvr2__poster');
      if(poster) this.player.poster=poster.currentSrc||poster.src; else this.player.removeAttribute('poster');
      this.player.src=source; this.player.muted=false; this.player.defaultMuted=false;
      this.player.loop=this.device('loop');
      try {this.player.volume=1;} catch(_) { /* System volume is controlled by iOS. */ }
      this.modal.querySelector('[data-customer]').textContent=card.dataset.caption;
      this.modal.querySelector('[data-verified-label]').hidden=card.dataset.verified!=='true';
      this.modal.querySelector('.cvr2-modal__count').textContent=`${index+1} / ${this.cards.length}`;
      this.modal.querySelector('[data-video-prev]').disabled=index===0;
      this.modal.querySelector('[data-video-next]').disabled=index===this.cards.length-1;
      this.player.load(); this.tryPlay();
    }
    tryPlay() {
      const token=++this.playToken;
      this.retry.hidden=true;
      const result=this.player.play();
      if(result) result.catch(()=>{if(this.isOpen && token===this.playToken) this.retry.hidden=false;});
    }
    lockPage() {
      if(this.savedPage) return;
      const body=document.body, html=document.documentElement;
      this.savedPage={x:scrollX,y:scrollY,body:{},overflow:html.style.overflow};
      for(const key of ['position','top','left','right','width','overflow']) this.savedPage.body[key]=body.style[key];
      body.style.position='fixed'; body.style.top=`-${this.savedPage.y}px`; body.style.left='0';body.style.right='0';body.style.width='100%';body.style.overflow='hidden';html.style.overflow='hidden';
      this.inertElements=[];
      for(const el of document.body.children) if(el!==this.modal && !['SCRIPT','STYLE','LINK'].includes(el.tagName) && !el.inert) {el.inert=true;this.inertElements.push(el);}
    }
    unlockPage() {
      this.inertElements?.forEach(el=>{el.inert=false;});this.inertElements=[];
      if(!this.savedPage) return;
      const saved=this.savedPage; this.savedPage=null;
      Object.assign(document.body.style,saved.body); document.documentElement.style.overflow=saved.overflow;
      const behavior=document.documentElement.style.scrollBehavior;document.documentElement.style.scrollBehavior='auto';
      window.scrollTo(saved.x,saved.y);document.documentElement.style.scrollBehavior=behavior;
    }
    close(restoreFocus=true) {
      if(!this.isOpen) return;
      this.isOpen=false; ++this.playToken;
      this.player.pause(); this.player.removeAttribute('src');this.player.removeAttribute('poster');this.player.load();
      this.modal.hidden=true;this.unlockPage();
      if(this.constructor.active===this) this.constructor.active=null;
      if(restoreFocus && this.opener?.isConnected) this.opener.focus({preventScroll:true});
      this.refreshAll();
    }
    disconnectedCallback() {
      if(!this.ready) return;
      this.ready=false;this.close(false);this.events.abort();this.observer?.disconnect();this.sectionObserver?.disconnect();this.resizeObserver?.disconnect();
      this.mobile.removeEventListener('change',this.changeMedia);this.motion.removeEventListener('change',this.changeMedia);
      cancelAnimationFrame(this.scrollFrame);cancelAnimationFrame(this.carouselFrame);cancelAnimationFrame(this.resizeFrame);this.videos.forEach(v=>v.pause());this.modal.remove();this.track.querySelectorAll('[data-clone]').forEach(c=>c.remove());this.ready=false;
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["modern-flex-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('modern-flex-hero')) return;
    class ModernFlexHero extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.mobile = matchMedia('(max-width: 749px)');
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
        this.videos = Array.from(this.querySelectorAll('.mh-video'));
        this.control = this.querySelector('.mh-video-control');
        this.visible = false;
        this.userChoice = new Map();
        this.onChange = () => this.update();
        this.mobile.addEventListener('change', this.onChange);
        this.reduced.addEventListener('change', this.onChange);
        this.addEventListener('click', event => this.onClick(event), options);
        document.addEventListener('visibilitychange', this.onChange, options);
        this.videos.forEach(video => {
          video.muted = true;
          video.addEventListener('playing', () => { video.classList.add('is-ready'); this.updateControl(); }, options);
          video.addEventListener('pause', () => this.updateControl(), options);
          video.addEventListener('ended', () => { this.userChoice.set(video, false); this.updateControl(); }, options);
          video.addEventListener('error', () => { video.classList.remove('is-ready'); this.updateControl(); }, options);
        });
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting;
          this.update();
        }, { threshold: 0 });
        this.observer.observe(this);
        this.update();
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.abort = null;
        this.observer?.disconnect();
        this.mobile?.removeEventListener('change', this.onChange);
        this.reduced?.removeEventListener('change', this.onChange);
        this.videos?.forEach(video => video.pause());
      }
      activeVideo() {
        return this.videos.find(video => video.dataset.device === (this.mobile.matches ? 'mobile' : 'desktop'));
      }
      loadVideo(video) {
        if (video.dataset.loaded) return;
        const template = this.querySelector(`template[data-sources="${video.dataset.device}"]`);
        if (!template) return;
        video.append(template.content.cloneNode(true));
        video.dataset.loaded = 'true';
        video.load();
      }
      update() {
        const mobile = this.mobile.matches;
        this.querySelectorAll('.mh-button').forEach(link => {
          const href = mobile ? link.dataset.hrefMobile : link.dataset.hrefDesktop;
          if (href) { link.setAttribute('href', href); link.removeAttribute('aria-disabled'); }
          else { link.removeAttribute('href'); link.setAttribute('aria-disabled', 'true'); }
        });
        // Keep physical alignment independent from text direction in the CTA row.
        const direction = getComputedStyle(this).direction;
        this.querySelectorAll('.mh-button').forEach(link => { link.dir = direction; link.style.direction = direction; });
        const active = this.activeVideo();
        this.videos.forEach(video => {
          const chosen = this.userChoice.get(video);
          const wantsPlay = chosen === true || (chosen === undefined && video.dataset.autoplay === 'true' && !this.reduced.matches);
          if (video !== active || !this.visible || document.hidden || !wantsPlay) { video.pause(); return; }
          this.loadVideo(video);
          if (video.paused) video.play().catch(() => this.updateControl());
        });
        this.updateControl();
      }
      updateControl() {
        const video = this.activeVideo();
        this.control.hidden = !video;
        if (!video) return;
        const playing = !video.paused && !video.ended;
        this.control.setAttribute('aria-label', playing ? this.dataset.pauseLabel : this.dataset.playLabel);
        this.control.querySelector('[data-play-icon]').toggleAttribute('hidden', playing);
        this.control.querySelector('[data-pause-icon]').toggleAttribute('hidden', !playing);
      }
      onClick(event) {
        if (!(event.target instanceof Element)) return;
        if (event.target.closest('.mh-video-control')) {
          const video = this.activeVideo();
          if (!video) return;
          if (video.paused) {
            this.userChoice.set(video, true);
            this.loadVideo(video);
            video.play().catch(() => this.updateControl());
          } else { this.userChoice.set(video, false); video.pause(); }
          this.updateControl();
          return;
        }
        const link = event.target.closest('.mh-button');
        if (!link || !link.hasAttribute('href') || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.target === '_blank') return;
        let url;
        try { url = new URL(link.href, location.href); } catch (_) { return; }
        if (url.origin !== location.origin || url.pathname !== location.pathname || url.search !== location.search || !url.hash) return;
        let id;
        try { id = decodeURIComponent(url.hash.slice(1)); } catch (_) { return; }
        const target = document.getElementById(id);
        if (!target) return;
        event.preventDefault();
        const offset = Number.parseFloat(getComputedStyle(this).getPropertyValue('--mh-offset')) || 0;
        const top = Math.max(0, target.getBoundingClientRect().top + window.scrollY - offset);
        const temporaryTabindex = !target.hasAttribute('tabindex') && !target.matches('a[href],button,input,select,textarea,[contenteditable="true"]');
        if (temporaryTabindex) target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });
        if (temporaryTabindex) target.addEventListener('blur', () => target.removeAttribute('tabindex'), { once:true });
        window.scrollTo({ top, behavior: this.dataset.smooth === 'true' && !this.reduced.matches ? 'smooth' : 'instant' });
        try { history.replaceState(history.state, '', url.hash); } catch (_) { /* Sandboxed previews can disallow history. */ }
      }
    }
    customElements.define('modern-flex-hero', ModernFlexHero);
  })();

  } catch(e) { console.error(e); }
})();
})();
